import React, { useEffect, useState } from "react";
import { AppContext } from "./context";
import {
  QuoteOptionsScreen,
  QuizFormScreen,
  SelectedOptionScreen,
  ConfirmationScreen,
  OutOfServiceAreaScreen,
  CustomerIsRenterScreen,
  CustomerRoomPlusFiveScreen,
} from "./screens";
import { Header } from "./components";
import { getShopifyOrder } from "./utils/get-shopify-order";

export const App = () => {
  const [currentStep, setCurrentStep] = useState("quiz");
  const [selectedOption, setSelectedOption] = useState(null);
  const [shopifyCustomer, setShopifyCustomer] = useState(null);
  const [shopifyOrder, setShopifyOrder] = useState(null);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [typeformAnswers, setTypeformAnswers] = useState([]);

  // Catch order from URL params, if there is an order, fetch the order and set the current step to confirmation
  useEffect(() => {
    const handleOrderFromParams = async () => {
      const orderId = new URLSearchParams(window.location.search).get(
        "completed"
      );

      if (orderId) {
        const order = await getShopifyOrder(orderId);
        setShopifyOrder(order);
        setCurrentStep("confirmation");
      }
    };

    handleOrderFromParams();
  }, []);

  return (
    <AppContext.Provider
      value={{
        currentStep,
        selectedOption,
        shopifyCustomer,
        shopifyOrder,
        options,
        isLoading,
        typeformAnswers,
        setCurrentStep,
        setSelectedOption,
        setShopifyCustomer,
        setOptions,
        setShopifyOrder,
        setIsLoading,
        setTypeformAnswers,
      }}
    >
      <Header />
      <div className="tw-max-w-[1256px] tw-mx-auto tw-px-5 md:tw-px-0">
        {
          {
            quiz: <QuizFormScreen />,
            quote: <QuoteOptionsScreen />,
            selected: <SelectedOptionScreen />,
            confirmation: <ConfirmationScreen />,
            outOfServiceArea: <OutOfServiceAreaScreen />,
            customerIsRenter: <CustomerIsRenterScreen />,
            customerRoomPlusFive: <CustomerRoomPlusFiveScreen />,
          }[currentStep]
        }
      </div>
    </AppContext.Provider>
  );
};

export default App;
